import { useContext, useEffect, useState } from "react";
import { GlobalInfo } from "../../Contexts/GlobalContext";
import { Accordion } from "react-bootstrap";
import TokenService from "../../Services/Token.service";
import { UserService } from "../../Services/User.service";

const Help= () =>{
    const { isSidebarVisible } = useContext(GlobalInfo);
    const userRole = TokenService.getUserRoles();

    const [FAQs, setFAQs] = useState([]);

     // Map role to type_id
    const typeIdMap = {
        "Admin": 1,
        "Requestor": 2,
        "Donor": 3,
        "Superadmin": 1   
    };

    console.log("user role is:",userRole);
    useEffect(() => {
        window.showloomvideofrom = function (section, time) {
            console.log("Jump to:", section, time);

            // Example: Scroll to iframe & set timestamp
            const iframe = document.querySelector("iframe");

            if (!iframe) return;

            const url = new URL(iframe.src);
            url.searchParams.set("t", time);

            iframe.src = url.toString();

            // Scroll into view
            iframe.scrollIntoView({ behavior: "smooth" });
        };
    }, []);

    useEffect(() => {
        if (!userRole || userRole.length === 0) return;

        // Extract first role 
        const role = userRole[0];

        // Convert role → type_id
        const type_id = typeIdMap[role] || 3;

        // Run API only if FAQs list is empty
        if (FAQs.length === 0) {
            const payload = { type_id };

            const fetchData = async () => {
                try {
                    const result = await UserService.getFAQs(payload);
                    if(result.data.length  !== 0){
                        setFAQs(result.data);      
                        console.log("result.data", result.data);
                    }
                } catch (err) {
                    console.error(err);
                }
            };
            fetchData();
        }

    }, [userRole]);
    function cleanHtml(html) {
        if (!html) return "";

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const unwantedClasses = [
            "col-1","col-2","col-3","col-4","col-5","col-6",
            "col-7","col-8","col-9","col-10","col-11","col-12",
            "col-sm-6","col-md-6","col-lg-6","col-xl-6","col-xxl-6"
        ];

        doc.querySelectorAll("*").forEach(el => {
            if (!el.classList) return;

            unwantedClasses.forEach(c => {
                if (el.classList.contains(c)) {
                    el.classList.remove(c);
                }
            });
        });

        return doc.body.innerHTML;
    }

    return (
    <>
        <div className={`qu-help-center-faq-section el-middle ${!isSidebarVisible ? "collapsed-body" : ""}`}>
            <div className="el-bg-table el-super-admin m-3">
                {FAQs.length === 0 && (<>
                    <div className="text-center mt-5">
                        <h3 className="m-auto">No FAQs available</h3>
                    </div>
                </>)}
                <Accordion
                    // alwaysOpen
                    // defaultActiveKey={FAQs.map((_, i) => i.toString())}
                    flush
                >

                    {FAQs.map((faq, index) => (
                        <Accordion.Item eventKey={index.toString()} key={index}>
                            <Accordion.Header>
                                <label>{faq.help_title}</label>
                            </Accordion.Header>

                          <Accordion.Body>
                            <div className="row">

                                {/* LEFT SIDE — CLEANED FAQ CONTENT */}
                                <div className="col-6">
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: cleanHtml(faq.help_content),
                                        }}
                                    />
                                </div>

                                {/* RIGHT SIDE — VIDEO */}
                                {faq.help_video && (
                                    <div className="col-6">
                                        <h3 className="mb-3">Video Tutorial</h3>
                                        <iframe
                                            src={faq.help_video}
                                            width="100%"
                                            height="350"
                                            frameBorder="0"
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                )}

                            </div>
                        </Accordion.Body>

                        </Accordion.Item>
                    ))}

                </Accordion>
                <div className="text-center mt-5"> 
                    <p className="m-auto">Can't find what you're looking for? <a href="mailto:help@donorxlabs.com" className="ms-2 back-link">Contact our support team</a></p>
                </div>
            </div>
        </div>
    </>
);


}
export default Help;